export const hasAnyNewTag = (recordsOrResponse: any): boolean => {
  const firstRecord = Array.isArray(recordsOrResponse)
    ? recordsOrResponse?.[0]
    : recordsOrResponse?.data?.[0] ?? recordsOrResponse?.[0];
  return Boolean(
    firstRecord?.NewTagID ||
      firstRecord?.NewTagIncome ||
      firstRecord?.NewTagBanking ||
      firstRecord?.NewTagOther ||
      firstRecord?.NewTagBankIncome
  );
};

export const hasNewTagForColumn = (
  columnSource: string | undefined,
  recordsOrResponse: any
): boolean => {
  if (!columnSource) return false;
  const firstRecord = Array.isArray(recordsOrResponse)
    ? recordsOrResponse?.[0]
    : recordsOrResponse?.data?.[0] ?? recordsOrResponse?.[0];
  if (!firstRecord) return false;

  const tagKeyByColumn: Record<string, keyof typeof firstRecord> = {
    ID: 'NewTagID',
    Income: 'NewTagIncome',
    Banking: 'NewTagBanking',
    Other: 'NewTagOther',
    BankIncome: 'NewTagBankIncome',
  } as any;

  const tagKey = tagKeyByColumn[columnSource];
  return Boolean(tagKey && (firstRecord as any)[tagKey]);
};

const toRecordsArray = (recordsOrResponse: any): any[] =>
  Array.isArray(recordsOrResponse)
    ? recordsOrResponse ?? []
    : recordsOrResponse?.data ?? [];

export const updateNewTagsForApplicants = async ({
  create,
  record,
  applicantData,
}: {
  create: (resource: string, params: any, options?: any) => any;
  record: { id?: any; NewTag?: boolean };
  applicantData: any;
}): Promise<void> => {
  if (!hasAnyNewTag(applicantData)) return;

  const applicationNumber = record?.id;
  await updateNewTagsForApplicantsUnconditional({
    create,
    applicationNumber,
    applicantData,
  });
};

export const updateNewTagsForApplicantsUnconditional = async ({
  create,
  applicationNumber,
  applicantData,
}: {
  create: (resource: string, params: any, options?: any) => any;
  applicationNumber: any;
  applicantData: any;
}): Promise<void> => {
  const applicants = toRecordsArray(applicantData);
  if (!applicationNumber || applicants.length === 0) return;

  for (const applicant of applicants) {
    for (const section of [1, 2, 3, 4, 5]) {
      create('updatenewtagsection', {
        data: {
          ApplicationNumber: applicationNumber,
          ApplicantID: applicant?.id,
          Section: section,
        },
      });
    }
  }
  create('updatenewtagapp', { data: { ApplicationNumber: applicationNumber } });
};
